"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const Picasso_1 = require("../Picasso");
Picasso_1.PicassoProvider.override(({ palette }) => ({
    MuiStepIcon: {
        text: {
            display: 'none'
        },
        root: {
            border: `1px solid ${palette.grey[200]}`,
            borderRadius: '50%',
            color: 'transparent',
            '&$completed': {
                border: 'none',
                color: palette.success.main
            },
            '&$active': {
                border: 'none'
            }
        }
    }
}));
exports.default = () => styles_1.createStyles({});
//# sourceMappingURL=styles.js.map